"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 241: BxROM (Hengge Technology)
 * ------------------------------------------------------------------ *
 * BxROM variant: 32 KB PRG bank switching via writes to $8000-$FFFF,
 * with optional battery-backed WRAM at $6000-$7FFF.
 * See https://www.nesdev.org/wiki/INES_Mapper_241
 */

function register(Mappers) {
  Mappers[241] = function (nes) {
    this.nes = nes;
    // PRG ROM bank select (5 bits: 32 banks of 16 KB = 512 KB max)
    this.prgBank = 0;
    // WRAM enable flag (bit 7 of register $8)
    this.wramEnabled = false;
    // WRAM select flag (bit 6 of register $8)
    this.wramSelect = false;
  };

  Mappers[241].prototype = new Mappers[0]();

  Mappers[241].prototype.write = function (address, value) {
    if (address < 0x8000) {
      // $6000-$7FFF: WRAM if enabled
      if (address >= 0x6000) {
        if (this.wramEnabled) {
          // Write to WRAM
          this.nes.cpu.mem[address] = value;
        }
        return;
      }
      Mappers[0].prototype.write.apply(this, arguments);
      return;
    }

    // $8000-$FFFF: PRG ROM bank select
    // Value is 5 bits wide (bits 4-0), selecting 32 KB bank
    this.prgBank = value & 0x1f;
    this.load32kRomBank(this.prgBank, 0x8000);

    // $6000-$7FFF: WRAM control
    if (address >= 0x6000 && address <= 0x7fff) {
      this.wramEnabled = (value & 0x80) !== 0;
      this.wramSelect = (value & 0x40) !== 0;
      if (this.wramEnabled && this.wramSelect) {
        // Enable WRAM: map cartridge WRAM to $6000-$7FFF
        // In this simple implementation, we just track the state
        // The actual mapping is handled by the CPU memory system
      }
    }
  };

  Mappers[241].prototype.loadROM = function () {
    if (!this.nes.rom.valid) {
      throw new Error("Mapper 241: Invalid ROM! Unable to load.");
    }

    // Load PRG-ROM: first 32 KB bank at $8000, last bank at $C000
    this.load32kRomBank(0, 0x8000);
    this.load32kRomBank(this.nes.rom.romCount - 1, 0xc000);

    // Load CHR data (if present)
    this.loadCHRROM();

    // Initialize WRAM state
    this.wramEnabled = false;
    this.wramSelect = false;

    // Reset interrupt handler
    this.resetIrqHandler();
  };
}

module.exports = { register: register };
